import SpeakerProfile from './SpeakerProfile';

export default SpeakerProfile;
